"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = require("angular");
var simple_filter_group_component_1 = require("../simple-filter/simple-filter-group.component");
var simple_filter_v2_component_1 = require("../simple-filter-v2/simple-filter-v2.component");
var simple_filter_v3_component_1 = require("../simple-filter-v3/simple-filter-v3.component");
var compare_to_component_1 = require("../compare-to/compare-to.component");
var broadcast_config_1 = require("../broadcast-config");
var report_options_helper_1 = require("../report-options.helper");
var filter_logic_1 = require("../filter-logic");
require('./main.component.css');
function isEmptyReportOption(reportOptionObj) {
    return !reportOptionObj || reportOptionObj === {};
}
var COMPONENT_NAME = 'smartorg.r6.reportOptions.main';
var AllowColorByEditCommands = ['COMPARE_VALUE', 'COMPARE_UNCERTAINTY', 'ISSUE_ANALYSIS', 'COMPARE_EXPERIMENT', 'ADD_TABLES', 'GMF_COMMERCIAL_EXPENSE', 'DISCOVERY_BREAKDOWN'];
var MainComponent = /** @class */ (function () {
    function MainComponent($scope, $timeout) {
        var _this = this;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.initValue();
        this.allCategories = [];
        this.categoriesForGroup = [];
        $scope.$on(broadcast_config_1["default"].INIT, function (event, args) { return __awaiter(_this, void 0, void 0, function () {
            var initState, defaultVal, isLeaf, isAdmin, categoryConfigs, nodeID, currentFilterLogic, tagStringArr, dropdownTagStringArr, numericIOs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initState = args.initState, defaultVal = args.defaultVal, isLeaf = args.isLeaf, isAdmin = args.isAdmin, categoryConfigs = args.categoryConfigs, nodeID = args.nodeID, currentFilterLogic = args.currentFilterLogic;
                        this.updateSpinner(true);
                        return [4 /*yield*/, this.smartorgApi.tagsFor(nodeID, currentFilterLogic)];
                    case 1:
                        tagStringArr = _a.sent();
                        return [4 /*yield*/, this.smartorgApi.dropdownTagsFor(nodeID, currentFilterLogic)];
                    case 2:
                        dropdownTagStringArr = _a.sent();
                        this.allTags = tagStringArr;
                        this.allDropdownTags = dropdownTagStringArr;
                        this.defaultOptions = defaultVal;
                        this.isLeaf = isLeaf;
                        this.isAdmin = isAdmin;
                        this.allowColorByEdit = true;
                        this.initCategories(tagStringArr, categoryConfigs);
                        this.addDropdownToCategories(dropdownTagStringArr);
                        this.initCategoriesForFilters(tagStringArr, dropdownTagStringArr);
                        this.initOptions(initState, defaultVal);
                        this.onUpdate();
                        return [4 /*yield*/, this.smartorgApi.getReportOptionNumericIOList(nodeID, currentFilterLogic)];
                    case 3:
                        numericIOs = _a.sent();
                        this.allNumericIOs = numericIOs;
                        this.initNumericObjects(numericIOs);
                        this.$timeout();
                        this.updateSpinner(false);
                        return [2 /*return*/];
                }
            });
        }); });
        $scope.$on(broadcast_config_1["default"].APPLY, function (event, args) {
            var options = args.options;
            var currentCommand = args.command;
            var allowColorByEdit = AllowColorByEditCommands.indexOf(currentCommand) >= 0;
            _this.allowColorByEdit = allowColorByEdit;
            _this.initOptions(options, _this.defaultOptions, allowColorByEdit);
            if (_this.isLeaf && options && 'compareToNodeID' in options) {
                //console.log("is leaf with compareTo");
            }
            else {
                _this.onUpdate();
            }
        });
        $scope.$on(broadcast_config_1["default"].RESET, function () {
            _this.onUpdateReset();
        });
        $scope.$on(broadcast_config_1["default"].CLEAR, function () {
            _this.initCategories([]);
            _this.initCategoriesForFilters([], []);
            _this.initNumericObjects({});
            _this.resetReportOptions();
        });
    }
    MainComponent.prototype.$onChanges = function (changeObjs) {
        if (changeObjs.fixedFilters) {
            if (this.fixedFilters) {
                var filterLogic = filter_logic_1.createFilterLogic(this.fixedFilters);
                this.fixedFilterCategoryNames = filterLogic.getAllCategoryNames();
            }
            else {
                this.fixedFilterCategoryNames = [];
            }
            this.initCategoriesForFilters(this.allTags, this.allDropdownTags);
            // this.initNumericObjects(this.allNumericIOs);
        }
    };
    MainComponent.prototype.updateSpinner = function (showSpinner) {
        this.$scope.$emit('reportOption:loaded', { showSpinner: showSpinner });
    };
    MainComponent.prototype.initValue = function () {
        this.filterQuery = null;
        this.initFilterQuery = null;
        this.expandUnassigned = false;
        this.groupByCategory = null;
        this.colorByCategory = null;
    };
    MainComponent.prototype.initCategories = function (tagList, categoryConfigs) {
        if (categoryConfigs === void 0) { categoryConfigs = null; }
        var categoryConfigMap = {};
        if (categoryConfigs) {
            categoryConfigs.forEach(function (cate) {
                categoryConfigMap[cate.CategoryName] = cate;
            });
        }
        this.allCategories = this.loadCategoriesFromTagString(tagList);
        if (categoryConfigMap) {
            this.allCategories.forEach(function (c) {
                if (!categoryConfigMap[c.name]) {
                    throw "Category " + c.name + " is not found in current definition!";
                }
                c.isMultiSelect = categoryConfigMap[c.name].IsMultiSelect === 'true';
            });
        }
        this.categoriesForGroup = [{ name: '<Subnodes>', entries: [] },
            { name: '<Leaves>', entries: [] }
        ].concat(this.allCategories);
    };
    ;
    MainComponent.prototype.addDropdownToCategories = function (dropdownTagList) {
        if (!dropdownTagList || typeof dropdownTagList === 'undefined') {
            return;
        }
        var dropdownItems = {};
        dropdownTagList.forEach(function (tag) {
            var t = tag.split(':');
            if (t.length !== 3) {
                return;
            }
            var key = t[0], codedVal = t[1], codedName = t[2];
            if (!dropdownItems[key]) {
                dropdownItems[key] = { entries: [], name: atob(decodeURIComponent(codedName)) };
            }
            dropdownItems[key]['entries'].push({ name: atob(decodeURIComponent(codedVal)) });
        });
        var dropdownCategories = Object.entries(dropdownItems).map(function (_a) {
            var key = _a[0], item = _a[1];
            return ({
                isDropdown: true,
                key: key,
                name: item.name,
                entries: item.entries.sort(function (a, b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; })
            });
        });
        this.allCategories = this.allCategories.concat(dropdownCategories)
            .sort(function (a, b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; });
        this.categoriesForGroup = [{ name: '<Subnodes>', entries: [] },
            { name: '<Leaves>', entries: [] }
        ].concat(this.allCategories);
    };
    MainComponent.prototype.initNumericObjects = function (numericIOs) {
        if (!numericIOs || typeof numericIOs === 'undefined') {
            this.numericObjects = [];
            return;
        }
        var validInputs = this.filterValidNumericalObject(numericIOs.Inputs, 'Inputs');
        var validOutputs = this.filterValidNumericalObject(numericIOs.Outputs, 'Outputs');
        var numericObjects = [].concat(validInputs).concat(validOutputs);
        numericObjects.sort(function (x1, x2) { return (x1.display > x2.display ? 1 : -1); });
        this.numericObjects = numericObjects;
    };
    MainComponent.prototype.filterValidNumericalObject = function (numericObjects, field) {
        if (!numericObjects || numericObjects.length === 0) {
            return [];
        }
        var validNumericObjects = numericObjects.filter(function (i) { return ('min' in i && typeof i.min === 'number'); });
        return validNumericObjects.map(function (o) {
            o['name'] = o.display + (o.units ? (' (' + o.units + ')') : '');
            o['field'] = field;
            return o;
        });
    };
    MainComponent.prototype.initCategoriesForFilters = function (allTags, allDropdownTags) {
        if (!allTags && !allDropdownTags) {
            this.categoriesForFilter = [];
            this.tagsForFilter = [];
            this.dropdownTagsForFilter = [];
            return;
        }
        var fixedNameSet = new Set(this.fixedFilterCategoryNames);
        this.categoriesForFilter = this.allCategories.filter(function (c) { return (!fixedNameSet.has(c.key) && !fixedNameSet.has(c.name)) || c.isMultiSelect; });
        var availableCategoryKeys = new Set(this.categoriesForFilter.map(function (c) { return c.isDropdown ? c.key : c.name; }));
        this.tagsForFilter = allTags.filter(function (t) { return availableCategoryKeys.has(t.split(':')[0]); });
        this.dropdownTagsForFilter = allDropdownTags.filter(function (t) { return availableCategoryKeys.has(t.split(':')[0]); });
    };
    MainComponent.prototype.loadCategoriesFromTagString = function (tagString) {
        var categories = {};
        tagString.forEach(function (tag) {
            var t = tag.split(':');
            if (t.length < 2) {
                return;
            }
            var categoryName = t[0], entry = t[1];
            if (!categories[categoryName]) {
                categories[categoryName] = [];
            }
            categories[categoryName].push({ name: entry });
        });
        return Object.entries(categories).map(function (_a) {
            var name = _a[0], entries = _a[1];
            return ({ name: name, entries: entries });
        }).sort(function (a, b) { return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1; });
    };
    MainComponent.prototype.processFilter = function (filterQuery) {
        var filterLogic = filter_logic_1.createFilterLogic(filterQuery);
        filterLogic.filter(new Set(this.tagsForFilter.concat(this.dropdownTagsForFilter)));
        return filterLogic.toExp();
    };
    MainComponent.prototype.initOptions = function (initState, defaultVal, allowColorByEdit) {
        if (allowColorByEdit === void 0) { allowColorByEdit = true; }
        this.initValue();
        var reportOptionObj = (isEmptyReportOption(initState) ? defaultVal : initState) || {};
        if (!this.isLeaf) {
            if (reportOptionObj.groupKey) {
                this.groupByCategory = this.categoriesForGroup.find(function (c) {
                    return (c.isDropdown ? c.key === reportOptionObj.groupKey : c.name === reportOptionObj.groupKey);
                });
                this.expandUnassigned = reportOptionObj.expandUnassignedForGroupBy || false;
            }
            if (reportOptionObj.colorKey) {
                if (allowColorByEdit || !reportOptionObj.groupKey) {
                    this.colorByCategory = this.categoriesForGroup.find(function (c) {
                        return (c.isDropdown ? c.key === reportOptionObj.colorKey : c.name === reportOptionObj.colorKey);
                    });
                }
                else {
                    this.colorByCategory = this.groupByCategory;
                }
            }
            if (reportOptionObj.filterLogic) {
                var filterQuery = this.processFilter(reportOptionObj.filterLogic);
                this.useAdvancedFilter = reportOptionObj.useAdvancedFilter;
                this.filterQuery = filterQuery;
                this.initFilterQuery = filterQuery;
            }
        }
        if (reportOptionObj.node) {
            this.$scope.$broadcast(broadcast_config_1["default"].COMPARE_SET, {
                node: reportOptionObj.node
            });
        }
    };
    MainComponent.prototype.autoFillColorBy = function () {
        var _this = this;
        this.colorByCategory = this.categoriesForGroup.find(function (c) { return c.name === _this.groupByCategory.name; });
    };
    MainComponent.prototype.getCurrentReportOptions = function () {
        var reportOptionObj = {};
        if (this.filterQuery) {
            reportOptionObj.useAdvancedFilter = this.useAdvancedFilter;
            reportOptionObj.filterLogic = this.filterQuery;
        }
        var compareNode = report_options_helper_1.getCompareToInfo();
        if (compareNode) {
            reportOptionObj.compareToNodeID = compareNode.id;
            reportOptionObj.compareToNodeName = compareNode.name;
        }
        if (this.groupByCategory) {
            var _a = this.groupByCategory, name_1 = _a.name, entries = _a.entries, key_1 = _a.key, isDropdown = _a.isDropdown;
            reportOptionObj.groupKey = isDropdown ? key_1 : name_1;
            // TODO: Historical reason, need to fix backend.
            reportOptionObj.groupByList = isDropdown ?
                JSON.stringify(entries.map(function (x) { return key_1 + ":" + encodeURIComponent(btoa(x.name)) + ":" + encodeURIComponent(btoa(name_1)); })) :
                JSON.stringify(entries.map(function (x) { return name_1 + ":" + x.name; }));
            reportOptionObj.expandUnassignedForGroupBy = this.expandUnassigned || false;
        }
        if (this.colorByCategory) {
            var _b = this.colorByCategory, name_2 = _b.name, entries = _b.entries, key_2 = _b.key, isDropdown = _b.isDropdown;
            reportOptionObj.colorKey = isDropdown ? key_2 : name_2;
            // TODO: Historical reason, need to fix backend.
            reportOptionObj.colorByList = isDropdown ?
                JSON.stringify(entries.map(function (x) { return key_2 + ":" + encodeURIComponent(btoa(x.name)) + ":" + encodeURIComponent(btoa(name_2)); })) :
                JSON.stringify(entries.map(function (x) { return name_2 + ":" + x.name; }));
        }
        return reportOptionObj;
    };
    MainComponent.prototype.onFilterSwitch = function () {
        this.initFilterQuery = this.filterQuery;
        this.$timeout();
    };
    MainComponent.prototype.updateFilter = function (filterQuery) {
        this.filterQuery = filterQuery;
    };
    MainComponent.prototype.addSimpleFilter = function () {
        this.$scope.$broadcast(broadcast_config_1["default"].ADD_FILTER);
    };
    MainComponent.prototype.onUpdate = function () {
        var reportOptionObj = this.getCurrentReportOptions();
        this.initFilterQuery = this.filterQuery;
        this.updateReportOptions({ reportOptionObj: reportOptionObj });
    };
    MainComponent.prototype.onApply = function () {
        var reportOptionObj = this.getCurrentReportOptions();
        this.initFilterQuery = this.filterQuery;
        this.applyReportOptions({ reportOptionObj: reportOptionObj });
    };
    MainComponent.prototype.resetReportOptions = function () {
        this.initValue();
        this.$scope.$broadcast(broadcast_config_1["default"].COMPARE_CLEAR);
        this.initOptions(null, this.defaultOptions);
        this.$scope.$broadcast('tree:reloadTree', {
            reportOptionString: this.getCurrentReportOptions()
        });
    };
    MainComponent.prototype.onUpdateReset = function () {
        this.resetReportOptions();
        this.onUpdate();
    };
    MainComponent.prototype.resetAndApply = function () {
        this.resetReportOptions();
        this.onApply();
        this.$scope.$broadcast('simpleFilter:reset', {
            defaultOptions: this.defaultOptions
        });
    };
    MainComponent.prototype.setDefaultReportOptions = function () {
        if (confirm('Save current report options as default, please confirm!')) {
            this.defaultOptions = this.getCurrentReportOptions();
            this.$scope.$emit(broadcast_config_1["default"].SET_DEFAULT, {
                reportOptions: this.defaultOptions
            });
            this.resetAndApply();
        }
    };
    return MainComponent;
}());
exports.MainComponent = MainComponent;
angular.module(COMPONENT_NAME, [simple_filter_group_component_1["default"], simple_filter_v2_component_1["default"], simple_filter_v3_component_1["default"], compare_to_component_1["default"]]).component("reportOptionsMain", {
    template: require("./main.component.html"),
    bindings: {
        smartorgApi: '=',
        fixedFilters: '<?',
        allowColorByEdit: '<',
        updateReportOptions: '&',
        applyReportOptions: '&',
        showAlert: '&?'
    },
    controller: MainComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=main.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options2/main/main.component.js